module.exports = __webpack_public_path__ + "img/beams.4eccbf0b.png";